import { all, takeEvery, put, call } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = { baseURL: siteConfig.siteUrl.API_URL };

const headers = () => ({
    Authorization: localStorage.getItem('access_token'),
    AuthId:        localStorage.getItem('id_token'),
    token:         localStorage.getItem('id_token'),
});

function* getMontajes(action) {
    yield put({ type: actions.SET_LOADING, value: true });
    const query = action.query ? `?${action.query}` : '';
    const res = yield gaxios.request({ url: `api/montajes${query}`, headers: headers() });
    if (res.data.success) {
        yield put({ type: actions.GET_MONTAJES_SUCCESS, payload: res.data.montajes });
    } else {
        notification('error', 'Error al cargar montajes');
        yield put({ type: actions.SET_LOADING, value: false });
    }
}

function* getMontaje(action) {
    yield put({ type: actions.SET_LOADING, value: true });
    const res = yield gaxios.request({ url: `api/montajes/${action.id}`, headers: headers() });
    if (res.data.success) {
        yield put({ type: actions.GET_MONTAJE_SUCCESS, payload: res.data.montaje });
    } else {
        notification('error', 'Error al cargar montaje');
        yield put({ type: actions.SET_LOADING, value: false });
    }
}

function* createMontaje({ payload }) {
    yield put({ type: actions.SET_LOADING, value: true });
    const res = yield gaxios.request({ url: 'api/montajes', method: 'POST', data: payload, headers: headers() });
    if (res.data.success) {
        notification('success', res.data.msg);
        yield put({ type: actions.CREATE_MONTAJE_SUCCESS, payload: res.data.montaje });
    } else {
        notification('error', res.data.msg || 'Error al crear montaje');
        yield put({ type: actions.SET_LOADING, value: false });
    }
}

function* updateMontaje({ payload }) {
    yield put({ type: actions.SET_LOADING, value: true });
    const res = yield gaxios.request({ url: `api/montajes/${payload._id}`, method: 'PUT', data: payload, headers: headers() });
    if (res.data.success) {
        notification('success', res.data.msg);
        yield put({ type: actions.UPDATE_MONTAJE_SUCCESS, payload: res.data.montaje });
    } else {
        notification('error', res.data.msg || 'Error al actualizar montaje');
        yield put({ type: actions.SET_LOADING, value: false });
    }
}

function* anularMontaje(action) {
    yield put({ type: actions.SET_LOADING, value: true });
    const res = yield gaxios.request({ url: `api/montajes/${action.id}/anular`, method: 'POST', headers: headers() });
    if (res.data.success) {
        notification('success', res.data.msg);
        yield put({ type: actions.ANULAR_MONTAJE_SUCCESS, id: action.id });
    } else {
        notification('error', res.data.msg || 'Error al anular montaje');
        yield put({ type: actions.SET_LOADING, value: false });
    }
}

function* previewConsumo(action) {
    yield put({ type: actions.SET_LOADING, value: true });
    const res = yield gaxios.request({ url: `api/montajes/${action.id}/preview`, headers: headers() });
    if (res.data.success) {
        yield put({ type: actions.PREVIEW_CONSUMO_SUCCESS, payload: res.data.items });
    } else {
        notification('error', res.data.msg || 'Error al calcular preview');
        yield put({ type: actions.SET_LOADING, value: false });
    }
}

function* confirmarMontaje(action) {
    yield put({ type: actions.SET_LOADING, value: true });
    const res = yield gaxios.request({
        url: `api/montajes/${action.id}/confirmar`,
        method: 'POST',
        data: action.payload,
        headers: headers(),
    });
    if (res.data.success) {
        notification('success', res.data.msg);
        yield put({ type: actions.CONFIRMAR_MONTAJE_SUCCESS, id: action.id });
    } else {
        notification('error', res.data.msg || 'Error al confirmar montaje');
        yield put({ type: actions.SET_LOADING, value: false });
    }
}

export default function* montajesSagas() {
    yield all([
        takeEvery(actions.GET_MONTAJES_REQUEST,    getMontajes),
        takeEvery(actions.GET_MONTAJE_REQUEST,     getMontaje),
        takeEvery(actions.CREATE_MONTAJE_REQUEST,  createMontaje),
        takeEvery(actions.UPDATE_MONTAJE_REQUEST,  updateMontaje),
        takeEvery(actions.ANULAR_MONTAJE_REQUEST,  anularMontaje),
        takeEvery(actions.PREVIEW_CONSUMO_REQUEST, previewConsumo),
        takeEvery(actions.CONFIRMAR_MONTAJE_REQUEST, confirmarMontaje),
    ]);
}
